import PaddingItemTop from "../ConfigParameters/PaddingItemTop";
import PaddingItemBottom from "../ConfigParameters/PaddingItemBottom";
import PaddingItemLeft from "../ConfigParameters/PaddingItemLeft";
import PaddingItemRight from "../ConfigParameters/PaddingItemRight";

export default class PaddingsItems {

    constructor(paddingTopBottom = {value: 15, unit: 'px'}, paddingLeftRight = {value: 15, unit: 'px'}, defaultUnits = ['px', '%']) {
        let paddingItemTop = new PaddingItemTop();
        paddingItemTop.setDefaultValue({...paddingTopBottom});
        paddingItemTop.setUnits(defaultUnits);
        paddingItemTop.setGroup('itemPosition');

        let paddingItemBottom = new PaddingItemBottom();
        paddingItemBottom.setDefaultValue({...paddingTopBottom});
        paddingItemBottom.setUnits(defaultUnits);
        paddingItemBottom.setGroup('itemPosition');

        let paddingItemLeft = new PaddingItemLeft();
        paddingItemLeft.setDefaultValue({...paddingLeftRight});
        paddingItemLeft.setUnits(defaultUnits);
        paddingItemLeft.setGroup('itemPosition');

        let paddingItemRight = new PaddingItemRight();
        paddingItemRight.setDefaultValue({...paddingLeftRight});
        paddingItemRight.setUnits(defaultUnits);
        paddingItemRight.setGroup('itemPosition');

        return {
            ...(paddingItemTop),
            ...(paddingItemBottom),
            ...(paddingItemLeft),
            ...(paddingItemRight),
        };
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigCollections/PaddingsItems.js